import { companyUrl } from "views_shared/app/javascript/utils/urls";

// Adapts a company-jobs row — as the profile providers store it, deserialized to camelCase through
// the employment serializer — into an <EmploymentSection> display row. Shared by every profile page
// that feeds the section, so one job renders the same wherever it appears.
export default function toEmploymentRow(job) {
  return {
    id: job.id,
    href: companyUrl({ slug: job.companySlug, migrate_id: job.companyMigrateId }),
    imageUrl: job.companyProfileImageUrl,
    name: job.companyName,
    jobTitle: job.title,
    from: job.from,
    to: job.to,
    featured: !!job.featured,
  };
}
